import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { ResellerExceedancesResponse } from '@utils/types/back-office/exceedances';

export const useGetResellerExceedances = () => {
  const fetchExceedances = async () => {
    const { resellerExceedances } = GET_URL();
    const { data } =
      await Axios.get<ResellerExceedancesResponse>(resellerExceedances);
    return data;
  };

  return useQuery<ResellerExceedancesResponse, AxiosError<BaseError>>(
    ['resellerExceedances'],
    fetchExceedances,
    {
      staleTime: 60_000,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: true
    }
  );
};
